import { useCallback, useEffect, useState } from 'react';
import type { FC } from 'react';
import { DeviceV2 } from 'src/Models/models';
import {
  Button,
  Box,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import axios from 'src/lib/axios';
import { useSnackbar } from 'notistack';
import { genUploadImageText, getBase64 } from 'src/utils/shareFunctions';
import { StorageImage } from 'reactfire';
import FileDropzone from '../../FileDropzone';
import 'firebase/storage';
import firebase from '../../../lib/firebase';
import { deleteImage } from 'src/dataservies/blobStoragedataserivce';
import { getDeviceImagesPublic } from 'src/dataservies/deviceDataservice';

interface UploadDeviceImageProps {
  device: DeviceV2;
  edit: boolean;
}

const UploadDeviceImage: FC<UploadDeviceImageProps> = (props) => {
  const { device, edit } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [files, setFiles] = useState<any[]>([]);
  const [imagesData, setImagesData] = useState<any[]>([]);
  const handledeleteImage = async (path) => {
    await deleteImage(path);
    location.reload();
  }
  const handleDrop = (newFiles: any): void => {
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };
  const handleImageOnClick = (e) => {
    window.open(e.target.src);
  };
  const handleRemove = (file): void => {
    setFiles((prevFiles) => prevFiles.filter((_file) => _file.path
      !== file.path));
  };
  const listFiles = useCallback(async () => {
    try {
      const images = await getDeviceImagesPublic(device.techTag);
      setImagesData(images);
    } catch (err) {
      console.error(err);
    }
  }, []);
  const handleUpload = (): void => {
    files.forEach((file: File) => {
      getBase64(file, async (base64) => {
        await axios.post('https://publicapiv2-vq6e2xdlea-uw.a.run.app/public/uploadDeviceImage', {
          techTag: device.techTag,
          fileName: file.name,
          baseString: base64,
          fileType: file.type
        });
        enqueueSnackbar('Image Uploaded', {
          autoHideDuration: 3000,
          anchorOrigin: {
            horizontal: 'right',
            vertical: 'top'
          },
          variant: 'success'
        });
      });
    });
    setFiles([]);
  };
  const handleRemoveAll = (): void => {
    setFiles([]);
  };
  useEffect(() => {
    listFiles();
  }, [listFiles]);
  return (
    <div className="gallery-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography className="gallery-title">
          {genUploadImageText(edit)}
        </Typography>
      </div>

      {imagesData.length > 0 ? (
        <div className="gallery-grid">
          {imagesData.map((item) => (
            <div key={item.url} className="image-card-wrapper">
              {edit && (
                <div className="delete-btn-overlay">
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => { handledeleteImage(item.name) }}
                    style={{ minWidth: 'unset', padding: '4px 8px' }}
                  >
                    Delete
                  </Button>
                </div>
              )}
              <img
                src={item.url}
                className="gallery-image"
                alt={item.name}
                onClick={handleImageOnClick}
              />
              <div className="image-overlay">
                <Typography variant="caption" style={{ color: 'white' }}>
                  {item.name}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-images-placeholder">
          <Typography variant="body1">No photos available for this device.</Typography>
        </div>
      )}

      {edit && (
        <Box sx={{ mt: 4 }}>
          <FileDropzone
            accept="image/*"
            files={files}
            onDrop={handleDrop}
            onRemove={handleRemove}
            onRemoveAll={handleRemoveAll}
            onUpload={handleUpload}
          />
        </Box>
      )}
    </div>
  );
};

UploadDeviceImage.propTypes = {
  // @ts-ignore
  device: PropTypes.object.isRequired,
  edit: PropTypes.bool.isRequired
};

export default UploadDeviceImage;
